module.exports = __webpack_public_path__ + "static/media/4.740e4f1c.svg";